import { render } from "./vr.vue?vue&type=template&id=49fcf2ba&scoped=true"
import script from "./vr.vue?vue&type=script&lang=js"
export * from "./vr.vue?vue&type=script&lang=js"

import "./vr.vue?vue&type=style&index=0&id=49fcf2ba&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fcf2ba"]])

export default __exports__